module.exports = __webpack_public_path__ + "img/profielfoto-linkedin.5f3157d4.png";